import React, { useState } from 'react';
import {
  Button,
  Row,
  Col,
  CloseButton,
  Form,
} from 'react-bootstrap';
import { cloneDeep } from 'lodash';
import { eAlertsCoreAPIEndpoint, ENDPOINTS } from '../../api';

export default function ManageParcel(props) {
  const { hideTabs, subscriptionGroup, alertTypes, updateParcels } = props;
  const [inProgress, setInProgress] = useState(false);
  const [subscriptionUpdates, setSubscriptionUpdates] = useState(
    cloneDeep(subscriptionGroup.subscriptions)
  );
  async function subscribe(parcelNumber, accountId, alertTypeId) {
    const newSubscription = {
      parcelNumber: `${parcelNumber}`,
      isActive: true,
      accountId: `${accountId}`,
      alertTypeId: `${alertTypeId}`,
    };
    await eAlertsCoreAPIEndpoint(ENDPOINTS.SUBSCRIPTION)
      .create(newSubscription)
      .then((Response) => {
        if (Response.status === 200) {
        } else {
        }
      })
      .catch((error) => {});
  }

  async function unsubscribe(subscriptionId) {
    await eAlertsCoreAPIEndpoint(ENDPOINTS.SUBSCRIPTION)
      .delete(subscriptionId)
      .then((Response) => {
        if (Response.status === 204) {
        }
      })
      .catch();
  }

  function updateSubscriptions(
    isActive,
    alertTypeId,
    accountId,
    subscription,
    isAllAlerts
  ) {
    //Setup:
    //Deep clone allows react state to "see" updates to the object.
    const newSubscriptionUpdates = cloneDeep(subscriptionUpdates);

    //1. Toggles between: AllAlerts or specific alerts.
    //Intended to avoid sending duplicate alert emails.
    if (
      //if user is *opting in to* AllAlerts, remove other subscriptions..
      isAllAlerts &&
      (newSubscriptionUpdates.find(
        (s) =>
          s.alertTypeId.toLowerCase() ===
          alertTypes
            .find((al) => al.alertName === 'All Alerts')
            ?.id.toLowerCase()
      )?.isActive === false ||
        newSubscriptionUpdates.find(
          (s) =>
            s.alertTypeId.toLowerCase() ===
            alertTypes
              .find((al) => al.alertName === 'All Alerts')
              ?.id.toLowerCase()
        ) === undefined)
    ) {
      newSubscriptionUpdates
        .filter(
          (s) =>
            s.alertTypeId.toLowerCase() !==
            alertTypes
              .find((al) => al.alertName === 'All Alerts')
              ?.id.toLowerCase()
        )
        .forEach((s) => (s.isActive = false));
    } else if (!isAllAlerts) {
      //if user interacts with one of the more specific alerts, remove AllAlerts...
      newSubscriptionUpdates
        .filter(
          (s) =>
            s.alertTypeId.toLowerCase() ===
            alertTypes
              .find((al) => al.alertName === 'All Alerts')
              ?.id.toLowerCase()
        )
        .forEach((s) => (s.isActive = false));
    }

    //2. Next, toggle the chosen subscription to active/inactive.
    if (
      //if the subscription already exists, toggle the isActive value.
      newSubscriptionUpdates.find(
        (a) => a.alertTypeId.toLowerCase() === alertTypeId.toLowerCase()
      )
    ) {
      const foundIndex = newSubscriptionUpdates.findIndex(
        (a) => a.alertTypeId.toLowerCase() === alertTypeId.toLowerCase()
      );
      newSubscriptionUpdates[foundIndex].isActive =
        !newSubscriptionUpdates[foundIndex].isActive;
    } else {
      //else if subscription does not exist - add enough info to create it later when form is submitted.
      newSubscriptionUpdates.push({
        isActive: isActive,
        alertTypeId: alertTypeId.toLowerCase(),
        accountId: accountId,
        parcelNumber: subscription,
      });
    }

    //3. Finally, update state with modified subscription info.
    setSubscriptionUpdates(newSubscriptionUpdates);
  }

  function submitSubscriptionForm(e) {
    e.preventDefault();
    // Loop through array to process each addition
    subscriptionUpdates.forEach((update) => {
      //match update subscriptions to original subscriptions
      const original = subscriptionGroup.subscriptions.find(
        (g) => g.alertTypeId === update.alertTypeId
      );
      if (original && update.isActive !== original.isActive) {
        //if a subscription was in both lists *and* the active property changed...
        if (update.isActive) {
          subscribe(update.parcelNumber, update.accountId, update.alertTypeId);
        } else {
          unsubscribe(original.id);
        }
      } else if (!original && update.isActive === true) {
        //else if the subscription is new and active, add subscription.
        subscribe(update.parcelNumber, update.accountId, update.alertTypeId);
      }
    });
    setInProgress(true);
    setTimeout(() => {
      updateParcels();
      hideTabs();
      setInProgress(false);
    }, 3000);
  }

  return (
    <div className="ep">
      <CloseButton onClick={hideTabs}></CloseButton>
      <h1 className="ep">Parcel #{subscriptionUpdates[0].parcelNumber}</h1>
      <Form onSubmit={submitSubscriptionForm}>
        {/*AllAlerts checkbox*/}
        <Row>
          <Col>
            <div className="all-alerts-checkbox">
              <Form.Check
                type="checkbox"
                id={alertTypes.find((al) => al.alertName === 'All Alerts')?.id}
                label={
                  alertTypes.find((al) => al.alertName === 'All Alerts')
                    ?.alertName
                }
                //if we found an AllAlerts ID in the subscription list...
                //checkbox will display as checked
                checked={
                  subscriptionUpdates.find(
                    (sub) =>
                      sub.alertTypeId.toLowerCase() ===
                      alertTypes.find((al) => al.alertName === 'All Alerts')?.id
                  )?.isActive
                    ? true
                    : ''
                }
                onChange={(e) =>
                  updateSubscriptions(
                    e.target.checked,
                    e.target.id,
                    subscriptionGroup.subscriptions[0].accountId,
                    subscriptionGroup.parcelNumber,
                    true
                  )
                }
              />
              <Form.Text>
                {
                  alertTypes.find((al) => al.alertName === 'All Alerts')
                    ?.description
                }
              </Form.Text>
            </div>
          </Col>
        </Row>
        <hr />
        {/*Specific alerts checkboxes*/}
        <Row>
          <Col>
            {
              //loop through specific alerts and create one checkbox for each
              alertTypes
                .filter((alert) => alert.alertName !== 'All Alerts')
                .map((alert) => (
                  <div key={alert.id} className="alerts-checkboxes">
                    <Form.Check
                      type="checkbox"
                      id={alert.id}
                      label={alert.alertName}
                      checked={
                        subscriptionUpdates.find(
                          (sub) =>
                            sub.alertTypeId.toLowerCase() ===
                            alert.id.toLowerCase()
                        )?.isActive
                          ? true
                          : ''
                      }
                      onChange={(e) =>
                        updateSubscriptions(
                          e.target.checked,
                          e.target.id,
                          subscriptionGroup.subscriptions[0].accountId,
                          subscriptionGroup.parcelNumber,
                          false
                        )
                      }
                    ></Form.Check>
                    <Form.Text className="ec">{alert.description}</Form.Text>
                  </div>
                ))
            }
          </Col>
        </Row>
        <Button variant="secondary" type="submit">
          {inProgress ? 'Saving...' : 'Save Changes'}
        </Button>
      </Form>
    </div>
  );
}
